import { useState } from 'react';
import classnames from 'classnames';

import style from './RemoveTemplatePopup.module.scss';
import '@components/mixins/commonStyles.scss';

import { Checkbox } from '@components/Checkbox';
import { Button, ButtonTheme } from '@components/Button';
import { ValueTemplateAttributes } from 'chaika-test-attributes';
import { translate } from '@chaika/i18n/helper';

interface Props {
    fieldName?: string;
    isGroup?: boolean;
    isSubGroup?: boolean;
    groupName?: string;
    templateText?: string;
    onConfirm(isChecked?: boolean): void;
    onCancel(): void;
}

export function RemoveTemplatePopup({
    isGroup = false,
    isSubGroup = false,
    fieldName,
    groupName,
    templateText,
    onConfirm,
    onCancel,
}: Props) {
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(prevIsChecked => !prevIsChecked);
    };

    const handleConfirmClick = () => {
        onConfirm(isChecked);
    };

    return (
        <div className={style.root}>
            {isGroup ? (
                <>
                    <div className={classnames(['font_h2', style.title])}>
                        {translate(isSubGroup ? 'deleteSubGroupQ' : 'deleteGroupQ')}
                    </div>
                    <div className={classnames(['font_body16Gray', style.text])}>
                        {translate('groupForField')} «{fieldName}»
                    </div>
                    <div className={classnames(['font_body16Black', style.text])}>{groupName}</div>
                    <div className={style.checkbox}>
                        <Checkbox
                            dataTest={ValueTemplateAttributes.SaveGroupTemplate}
                            label={translate('saveNestedTemplates')}
                            isChecked={isChecked}
                            onChange={handleCheckboxChange}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className={classnames(['font_h2', style.title])}>
                        {translate('groupTemplateFormButtonRemove')}?
                    </div>
                    {fieldName && (
                        <div className={classnames(['font_body16Gray', style.text])}>
                            {translate('groupTemplateTextFieldTitle')} «{fieldName}»
                        </div>
                    )}
                    <div className={classnames(['font_body16Black', style.text])}>{templateText}</div>
                </>
            )}
            <div className={style.buttons}>
                <div className={style.button}>
                    <Button
                        dataTest={ValueTemplateAttributes.ConfirmRemove}
                        label={translate('yesRemove')}
                        theme={ButtonTheme.Danger}
                        onClick={handleConfirmClick}
                    />
                </div>
                <div className={style.button}>
                    <Button
                        dataTest={ValueTemplateAttributes.CancelRemove}
                        label={translate('cancel')}
                        theme={ButtonTheme.Secondary}
                        onClick={onCancel}
                    />
                </div>
            </div>
        </div>
    );
}
